/**
 * Shared PageHeader component (design-system Phase 2).
 * Not yet imported by any existing page — safe to iterate on.
 *
 * Renders exactly one semantic <h1> per page. Replaces the four
 * inconsistent title patterns found in the UI audit (hub h2 titles,
 * bare unstyled headings, inline-style headings, div-based titles).
 *
 * Props:
 *  - title (required), subtitle (optional)
 *  - breadcrumbs: optional node, rendered above the title in a <nav>
 *  - actions: optional node, wraps/stacks below the title on narrow screens
 */
export default function PageHeader({
  title,
  subtitle,
  breadcrumbs,
  actions,
  className = '',
  ...rest
}) {
  return (
    <header className={`ds-page-header ${className}`.trim()} {...rest}>
      {breadcrumbs && (
        <nav className="ds-page-header-breadcrumbs" aria-label="Breadcrumb">
          {breadcrumbs}
        </nav>
      )}
      <div className="ds-page-header-row">
        <div className="ds-page-header-heading">
          <h1 className="ds-page-header-title">{title}</h1>
          {subtitle && <p className="ds-page-header-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="ds-page-header-actions">{actions}</div>}
      </div>
    </header>
  );
}
